import {Component, HostListener, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SwUpdate} from '@angular/service-worker';
import {ConfirmDialogComponent} from './components/shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'consents-web-client';
  private readonly publicKey = 'BHMDCogtUl9Pai91baGIiPJBHuKwNma4e7-Rxg5pWmDxbktn_LxO154FWBWat1D_0wHSE9zcDN1pnzoFmHgRD3E';

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    // console.log('clicked');
  }

  constructor(private swUpdate: SwUpdate, public dialog: MatDialog) {
    this.updateClient();
  }

  ngOnInit(): void {
    window.onbeforeunload = (event) => {
      console.log('closing');
    };

    window.onunload = (event) => {

      // window.localStorage.removeItem('user');
      // window.localStorage.removeItem('token');
    };
  }

  updateClient() {
    if (!this.swUpdate.isEnabled) {
      console.log('Update not enabled');
      return;
    }

    this.swUpdate.available.subscribe((event) => {
      console.log(`current: `, event.current, `available: `, event.available);
      const updateDialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          icon: 'update',
          title: 'Ειδοποίηση Ενημέρωσης',
          message: 'Υπάρχει μία νέα ενημέρωση για την εφαρμογή. Θέλετε να αναβαθμίσετε την εφαρμογή σας τώρα?'
        }
      });

      updateDialog.afterClosed().subscribe(result => {
        if (result) {
          this.swUpdate.activateUpdate().then(() => location.reload());
        }
      });
    });
  }

    updateMessage($event: any) {

    }
}
